jQuery( document ).ready( function ( $ ) {

	/*Mini-cart remove and update actions*/

	/*global myajax*/
	const __remove_cart_item = function () {
			$( '.remove_from_cart_button' ).off().on( 'click', function ( e ) {
				$( this ).parents( '.wtc-mini-cart' ).first().block( {
					message: '',
					overlayCSS: {
						backgroundColor: '#fff',
						opacity: '.4'
					}
				} );
				$.post(
					myajax.ajaxurl,
					{ action: 'wtb_update_minicart', remove: $( this ).data( 'cart_item_key' ) },
					function ( r ) {
						if ( r.cart ) {
							$( '#site-header-cart .cart-contents__count' ).html( r.count );
							$( '#site-header-cart .wtc-mini-cart' ).replaceWith( r.cart );
							__remove_cart_item();
						} else
							console.log( r );
					}
				);
				e.preventDefault();
				e.stopPropagation();
				return false;
			} );
		},

		__refresh_minicart = function () {
			$.post(
				myajax.ajaxurl,
				{ action: 'wtb_update_minicart' },
				function ( r ) {
					if ( r.cart ) {
						$( '#site-header-cart .cart-contents__count' ).html( r.count );
						$( '#site-header-cart .wtc-mini-cart' ).replaceWith( r.cart );
						__remove_cart_item();
					} else
						console.log( r );
				}
			);
		};

	/**
	 * Primary Theme JS initialization
	 *
	 * @private
	 */
	const __theme_js_init = function () {

		// vars ============================================================================================================

		const windowElement = $( window ),
			documentElement = $( document ),
			headerElement = $( '.site-header' ),
			mobileMenu = $( '.mobile-menu' ),
			mainNavMenuItemHasChildren = $( '.main-navigation .menu-item-has-children' ),
			mainNavSubMenuElement = $( '.main-navigation .sub-menu' ),
			burgerButton = $( '.toggle-menu-button' ),
			burgerButtonElements = $( '.toggle-menu-button__item' ),
			productGalleryWrappers = $( '.products .woocommerce-product-gallery__wrapper, .single-product .woocommerce-product-gallery__wrapper' ),
			blogPostsLoaderImg = $( '.posts-grid .loader' ),
			bodyElement = $( 'body' ),
			htmlBodyElements = $( 'html, body' ),
			popularProductsSlider = $( '.popular-products__slider' ),
			poplarProductsHomeSlider = $( '.popular-products-home__slider .products' ).not( 'section' ),
			reviewLinks = $( '.product-info-wrapper .woocommerce-review-link' );

		let viewportWidth = document.documentElement.clientWidth;

		const styleHeaderIfWindowScrolled = () => {
			if ( windowElement.scrollTop() > 40 ) {
				headerElement.addClass( 'scrolled' );
			} else {
				headerElement.removeClass( 'scrolled' );
			}
		};

		styleHeaderIfWindowScrolled();
		determineMobileMenuHeight();

		windowElement.on('scroll resize', () => {
			styleHeaderIfWindowScrolled();
			determineMobileMenuHeight();
		});

		function determineMobileMenuHeight() {
			const react = headerElement[0].getBoundingClientRect();
			const headerOffset = react.bottom;
			mobileMenu.css('height', 'calc(100vh - ' + headerOffset + 'px)');
		}

		// header navigation-menu ==========================================================================================

		burgerButton.on( 'click', () => {
			mobileMenu.toggleClass( 'show' );
			if ( mobileMenu.hasClass( 'show' ) ) {
				htmlBodyElements.addClass( 'no-scroll' );
				burgerButtonElements.addClass( 'active' );
				$( '.site-header.transparent' ).addClass( 'white-bg' );
			} else {
				htmlBodyElements.removeClass( 'no-scroll' );
				burgerButtonElements.removeClass( 'active' );
				$( '.site-header.transparent' ).removeClass( 'white-bg' );
			}
		} );

		if ( !bodyElement.hasClass( 'woocommerce-checkout' ) ) {

			mainNavMenuItemHasChildren.on( 'click', () => {
				if ( viewportWidth < 992 ) {
					mainNavMenuItemHasChildren.toggleClass( 'active' );
					mainNavSubMenuElement.slideToggle();
				}
			} );

			if (viewportWidth < 992) {
				mainNavSubMenuElement.hide();
			}

			windowElement.on( 'resize', () => {
				viewportWidth = document.documentElement.clientWidth;

				// defineHeaderOffsetTop();

				if ( viewportWidth < 992 ) {
					if ( !mainNavMenuItemHasChildren.hasClass( 'active' ) ) {
						mainNavSubMenuElement.hide();
					}
				} else {
					mainNavMenuItemHasChildren.removeClass( 'active' );
					mainNavSubMenuElement.removeAttr( 'style' );
					mobileMenu.removeAttr( 'style' );
					mobileMenu.removeClass( 'show' );
					if ( htmlBodyElements.hasClass( 'no-scroll' ) ) {
						htmlBodyElements.removeClass( 'no-scroll' );
					}
				}
			} );
		}

		// footer nav-menu =================================================================================================

		const hideFooterMenusOnMobile = () => {
			$( '.footer .menu' ).hide();
			$( '.footer .widget_nav_menu .widget-title' ).removeClass( 'active' );
		};

		if ( viewportWidth < 768 ) {
			hideFooterMenusOnMobile();
		}

		windowElement.on( 'resize', () => {
			viewportWidth = document.documentElement.clientWidth;

			if ( viewportWidth < 768 ) {
				hideFooterMenusOnMobile();
			} else {
				$( '.footer .menu' ).removeAttr( 'style' );
			}
		} );

		$( '.footer .widget_nav_menu .widget-title' ).on( 'click', event => {
			if ( $( event.currentTarget ).hasClass( 'active' ) ) {
				$( event.currentTarget ).removeClass( 'active' );
				$( event.currentTarget ).parents( '.column' ).find( '.menu' ).slideUp();
			} else {
				$( event.currentTarget ).addClass( 'active' );
				$( event.currentTarget ).parents( '.column' ).find( '.menu' ).slideDown();
				$( event.currentTarget ).parents( '.column' ).siblings( '.column' ).find( '.widget_nav_menu .widget-title' ).removeClass( 'active' );
				$( event.currentTarget ).parents( '.column' ).siblings( '.column' ).find( '.menu' ).slideUp();
			}
		} );

		// Product images carousel =========================================================================================

		productGalleryWrappers.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
		} );

		// Popular products carousel =======================================================================================

		popularProductsSlider.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: true,
			centerMode: true,
			centerPadding: false,
			mobileFirst: true,
			responsive: [ {
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: false,
					centerMode: false,
					centerPadding: true
				}
			} ]
		} );

		// Popular products carousel on home page =======================================================================================

		poplarProductsHomeSlider.slick( {
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: false,
			arrows: true,
			dots: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinite: false,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: false,
						centerMode: true,
						centerPadding: false
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: false,
						arrows: false,
						centerMode: true,
						centerPadding: false
					}
				}
			]
		} );

		// Product accordion ===============================================================================================

		const productAccordionTitles = $( '.accordion-area__title' ),
			accordionAreaContent = $( '.accordion-area__content' );

		accordionAreaContent.hide();

		productAccordionTitles.off().on( 'click', event => {
			if ( $( event.currentTarget ).hasClass( 'active' ) ) {
				productAccordionTitles.removeClass( 'active' );
				accordionAreaContent.slideUp( 300 );
			} else {
				productAccordionTitles.removeClass( 'active' );
				$( event.currentTarget ).addClass( 'active' );
				accordionAreaContent.slideUp( 300 );
				$( event.currentTarget ).siblings( '.accordion-area__content' ).slideDown( 300 );
				$( '.reviews .comment-list' ).slick( 'setPosition' );
			}
		} );

		// Scroll to reviews and open them if reviews-link is clocked ======================================================

		reviewLinks.on( 'click', event => {
			event.preventDefault();
			const currentProductReviews = document.querySelector( '#reviews' );
			currentProductReviews.scrollIntoView( { block: 'center', behavior: 'smooth' } );
		} );

		// Ingredients slider ==============================================================================================
		const mobileOnlySlider = ( selector ) => {
			$( selector ).slick( {
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				centerMode: true,
				centerPadding: false,
				arrows: false,
				responsive: [ {
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: true,
					}
				},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: true,
						}
					} ]
			} );
		};

		if ( $( window ).width() < 991 ) {
			mobileOnlySlider( '.ingredients-slider .fl-col-group.fl-col-group-nested:nth-child(3)' );
		}

		// Single product gallery height ===================================================================================

		const productGalleries = document.querySelectorAll( '.woocommerce-product-gallery' );

		if ( windowElement.width() > 991 ) {
			productGalleries.forEach( ( gallery ) => {
				const images = gallery.querySelectorAll( '.product-image' );
				images.forEach( ( image, i ) => {
					// image.onload = function () {
					if ( i === images.length - 1 ) {
						gallery.querySelector( '.woocommerce-product-gallery__wrapper' ).style.maxHeight = gallery.parentElement.offsetHeight + 'px';
					}
					// };
				} );
			} );
		}

		windowElement.on( 'resize', event => {
			if ( $( event.currentTarget ).width() <= 991 ) {
				productGalleryWrappers.removeAttr( 'style' );
			} else {
				productAccordionTitles.removeClass( 'active' );
				accordionAreaContent.hide();
				productGalleries.forEach( ( gallery ) => {
					gallery.querySelector( '.woocommerce-product-gallery__wrapper' ).style.maxHeight = gallery.parentElement.offsetHeight + 'px';
				} );
			}
		} );

		// Create select on account page for window size - 768px

		$( '.woocommerce-MyAccount-navigation-link.is-active' ).on( 'click', function () {

			// on reload page

			if ( $( window ).width() < 992 ) {
				$( this ).toggleClass( 'open' );
				if ( $( this ).hasClass( 'open' ) ) {
					$( '.woocommerce-MyAccount-navigation ul li:nth-child(1)' ).before( $( '.woocommerce-MyAccount-navigation-link.is-active.open' ) );
					$( '.woocommerce-MyAccount-navigation-link' ).slideDown( 200 );
				} else {
					$( '.woocommerce-MyAccount-navigation-link' ).not( '.is-active' ).slideUp( 200 );

				}
			} else {
				$( this ).removeClass( 'open' );

			}

			// resize page

			$( window ).resize( function () {
				if ( $( window ).width() < 992 ) {
					if ( $( '.woocommerce-MyAccount-navigation-link.is-active' ).hasClass( 'open' ) ) {
						$( '.woocommerce-MyAccount-navigation-link' ).slideDown( 200 );
					} else {
						$( '.woocommerce-MyAccount-navigation-link' ).not( '.is-active' ).slideUp( 200 );

					}
				} else {
					$( '.woocommerce-MyAccount-navigation-link.is-active' ).removeClass( 'open' );
					$( '.woocommerce-MyAccount-navigation-link' ).show();

				}
			} );

		} );

		// Expand and collapse the list of categories on blog pages ========================================================

		const activeCatMobile = $( '.active-cat-mobile' );
		const categoriesList = $( '.blog-archives-categories' );

		activeCatMobile.on( 'click', event => {
			const _this = $( event.currentTarget );
			const _thisList = _this.siblings( '.blog-archives-categories' );

			if ( _this.hasClass( 'active' ) ) {
				_this.removeClass( 'active' );
				_thisList.slideUp();
			} else {
				_this.addClass( 'active' );
				_thisList.slideDown();
			}
		} );

		windowElement.on( 'resize', event => {
			activeCatMobile.removeClass( 'active' );
			if ( $( event.currentTarget ).width() > 991 ) {
				categoriesList.removeAttr( 'style' );
			} else {
				categoriesList.slideUp();
			}
		} );

		// Add div pause and teg h1 after subscription detail in the account page

		// copy link from input

		const copyToClipboard = ( str ) => {
			let strText = $( str ).val();
			const el = document.createElement( 'textarea' );
			el.value = strText;
			el.setAttribute( 'readonly', '' );
			el.style.position = 'absolute';
			el.style.left = '-9999px';
			document.body.appendChild( el );
			el.select();
			document.execCommand( 'copy' );
			document.body.removeChild( el );
			$( '.copy-button-wrapper' ).addClass( 'active' );
		};

		$( '.copy-button' ).on( 'click', function () {
			copyToClipboard( '#copy-link' );
			setTimeout( function () {
				$( '.copy-button-wrapper' ).removeClass( 'active' );
			}, 1000 );
		} );

		// Select on account page - dogs profile

		if ( bodyElement.hasClass( 'woocommerce-account' ) ) {
			const select = ( element ) => {
				$( element ).each( function ( index, item ) {
					const _this = $( this ),
						selectOption = _this.find( 'option' ),
						selectOptionLength = selectOption.length,
						duration = 200; // длительность анимации

					let textSelect = $( item ).children( 'option:selected' ).text();

					const mainBlock = $( '<div></div>', {
						class: 'new-select',
						text: textSelect
					} );

					_this.after( mainBlock );

					const selectHead = _this.next( '.new-select' );

					const list = $( '<ul>', {
						class: 'new-select__list'
					} );
					mainBlock.after( list );

					const selectList = selectHead.next( '.new-select__list' );
					for ( let i = 0; i < selectOptionLength; i++ ) {
						$( '<li>', {
							class: 'new-select__item',
							html: $( '<span>', {
								text: selectOption.eq( i ).text()
							} )
						} )
							.attr( 'data-value', selectOption.eq( i ).val() )
							.attr( 'selected', selectOption.eq( i ).attr( 'selected' ) )
							.appendTo( selectList );
						if ( selectOption.eq( i ).attr( 'selected' ) ) {
							selectHead.addClass( 'new-select__sort-by-' + selectOption.eq( i ).val() );
						}
					}

					const selectItem = selectList.find( '.new-select__item' );

					selectHead.on( 'click', function ( event ) {
						if ( !$( event.currentTarget ).hasClass( 'on' ) ) {
							$( event.currentTarget ).parents( '.dog-profile' ).siblings( '.dog-profile' ).find( '.new-select__list' ).slideUp( duration );
							$( event.currentTarget ).parents( '.dog-profile' ).siblings( '.dog-profile' ).find( '.new-select' ).removeClass( 'on' );
							$( event.currentTarget ).parents( '.dog-profile' ).find( '.new-select__list' ).slideUp( duration );
							$( event.currentTarget ).parents( '.dog-profile' ).find( '.new-select' ).removeClass( 'on' );

							$( event.currentTarget ).addClass( 'on' );
							selectList.slideDown( duration );

						} else {
							$( this ).removeClass( 'on' );
							selectList.slideUp( duration );

						}

					} );

					selectItem.on( 'click', function ( event ) {
						let chooseItem = $( event.currentTarget ).data( 'value' );

						let itemText = $( event.currentTarget ).children().text();
						selectOption.removeAttr( 'selected' );
						_this.find( 'option[value="' + chooseItem + '"]' ).attr( 'selected', 'selected' );
						$( event.currentTarget ).parents( '.new-select__list' ).siblings( '.new-select' ).text( itemText );

						selectList.slideUp( duration );

						selectHead.removeClass( 'on' );

					} );
				} );
			};

			select( 'select.breed_type' );
			select( 'select.current_food.option' );
			select( 'select.age_group' );

			// custom check in the account page - dogs profile

			$( 'span.option' ).each( function ( index, element ) {

				if ( $( element ).children( 'input' ).attr( 'checked' ) ) {
					$( element ).addClass( 'open' );
				}

				$( element ).on( 'click', function ( event ) {

					if ( !$( event.currentTarget ).hasClass( 'open' ) ) {
						$( event.currentTarget ).siblings( 'span.option' ).removeClass( 'open' );
						$( event.currentTarget ).siblings( 'span.option' ).children( 'input' ).removeAttr( 'checked' );

						$( element ).addClass( 'open' );
						$( element ).children( 'input' ).attr( 'checked', 'checked' );
					}

				} );
			} );
		}

		// Infinite scroll on blog pages ===================================================================================

		windowElement.on( 'scroll', function () {
			if ( $( '#true_loadmore' ).length > 0 ) {
				const bottomOffset = 2000;
				const data = {
					'action': 'loadmore',
					'query': true_posts,
					'page': current_page
				};
				if ( documentElement.scrollTop() > ( documentElement.height() - bottomOffset ) && !bodyElement.hasClass( 'loading' ) ) {
					$.ajax( {
						url: ajaxurl,
						data: data,
						type: 'POST',
						beforeSend: function ( xhr ) {
							bodyElement.addClass( 'loading' );
							if ( current_page !== Number( max_pages ) ) {
								blogPostsLoaderImg.removeClass( 'loader--hidden' );
							} else {
								blogPostsLoaderImg.hide();
							}
						},
						success: function ( data ) {
							if ( data ) {
								$( '#true_loadmore' ).before( data );
								current_page++;
							}
							bodyElement.removeClass( 'loading' );
							blogPostsLoaderImg.addClass( 'loader--hidden' );
						}
					} );
				}
			}
		} );

		// Increment post views counter ====================================================================================

		if ( bodyElement.hasClass( 'single' ) ) {
			const postID = $( 'article[data-post-id]' ).data( 'post-id' );
			if ( !sessionStorage.hasOwnProperty( 'post_id_' + postID ) ) {
				sessionStorage.setItem( 'post_id_' + postID, 'visited' );
				const url = window.location.origin + window.location.pathname + '?post_id=' + postID;
				$.get( url );
			}
		}

		// Toggle button on order page ====================================================================================

		const toggleOrder = item => {
			$( item ).each( function ( index, element ) {
				$( this ).on( 'click', function ( event ) {

					if ( !$( event.currentTarget ).hasClass( 'active' ) ) {
						$( event.currentTarget ).parents( '.woocommerce-orders-table-main' ).siblings( '.woocommerce-orders-table-main' ).children( '.woocommerce-product-order-data-wrapper' ).slideUp( 200 );
						$( window ).resize( function () {
							if ( $( window ).width() < 768 ) {
								$( this ).parents( '.woocommerce-orders-table-main' ).siblings( '.woocommerce-orders-table-main' ).children( '.woocommerce-orders-table__row' ).children( '.toggle-icons-wrapper' ).children( item ).fadeIn( 200 );
							}
						} );
						if ( $( window ).width() < 768 ) {
							$( this ).parents( '.woocommerce-orders-table-main' ).siblings( '.woocommerce-orders-table-main' ).children( '.woocommerce-orders-table__row' ).children( '.toggle-icons-wrapper' ).children( '.toggle-icons-mobile' ).fadeIn( 200 );
						} else {
							$( this ).parents( '.woocommerce-orders-table-main' ).siblings( '.woocommerce-orders-table-main' ).children( '.woocommerce-orders-table__row' ).children( '.toggle-icons-wrapper' ).children( '.toggle-icons-mobile' ).fadeOut( 200 );
						}

						$( event.currentTarget ).parents( '.woocommerce-orders-table-main' ).siblings( '.woocommerce-orders-table-main' ).children( '.woocommerce-orders-table__row' ).children( '.toggle-icons-wrapper' ).children( item ).removeClass( 'active' );
						$( event.currentTarget ).parents( '.woocommerce-orders-table-main' ).siblings( '.woocommerce-orders-table-main' ).children( '.woocommerce-orders-table__row' ).css( 'border-bottom', '2px solid #eee9ee' );

						$( element ).addClass( 'active' );

						// mobile

						$( '.close-btn-order' ).on( 'click', function () {
							$( element ).removeClass( 'active' );
							$( element ).parents( '.woocommerce-orders-table__row' ).siblings( '.woocommerce-product-order-data-wrapper' ).slideUp( 200 );
							$( '.toggle-icons-mobile' ).fadeIn( 200 );
							$( '.close-btn-order' ).parents( '.woocommerce-product-order-data-wrapper' ).siblings( '.woocommerce-orders-table__row' ).css( 'border-bottom', '2px solid #eee9ee' );
						} );

						// resize

						$( window ).resize( function () {
							$( element ).removeClass( 'active' );
							$( element ).parents( '.woocommerce-orders-table__row' ).siblings( '.woocommerce-product-order-data-wrapper' ).slideUp( 200 );
							$( '.close-btn-order' ).parents( '.woocommerce-product-order-data-wrapper' ).siblings( '.woocommerce-orders-table__row' ).css( 'border-bottom', '2px solid #eee9ee' );

						} );

						$( this ).parents( '.woocommerce-orders-table__row' ).siblings( '.woocommerce-product-order-data-wrapper' ).slideDown( 200 );
						$( this ).parents( '.woocommerce-orders-table__row' ).css( 'border-bottom', '0' );
					} else {
						$( this ).removeClass( 'active' );
						$( this ).parents( '.woocommerce-orders-table__row' ).siblings( '.woocommerce-product-order-data-wrapper' ).slideUp( 200 );
						$( this ).parents( '.woocommerce-orders-table__row' ).css( 'border-bottom', '2px solid #eee9ee' );

					}

				} );
			} );
		};
		toggleOrder( '.toggle-icons' );
		toggleOrder( '.toggle-icons-mobile' );

		// View more in the order account page
		if ( $( '.woocommerce-orders-table' ).children().length > 9 ) {
			$( '.woocommerce-orders-table-main' ).slice( 0, 7 ).show();
			$( '.view-all-orders' ).click( function ( e ) {
				e.preventDefault();
				$( '.woocommerce-orders-table-main:hidden' ).slice( 0, 7 ).slideDown( 200 );
				if ( $( '.woocommerce-orders-table-main:hidden:hidden' ).length == 0 ) {
					$( '.view-all-orders' ).fadeOut( 200, 0 );
				} else if ( $( '.woocommerce-orders-table-main:hidden:hidden' ).length < 7 ) {
					$( '.view-all-orders' ).hide();
				}
			} );
		} else {
			$( '.woocommerce-orders-table-main' ).show();
			$( '.view-all-orders-wrapper' ).hide();
		}

		// Change line on welcome page if products equals 1 or 2

		$( '.line-data' ).each( function ( index, element ) {
			if ( $( element ).children().length === 1 ) {
				$( element ).children().css( 'border-radius', '10px' );
			} else if ( $( element ).children().length === 2 ) {
				$( element ).children().eq( 1 ).css( 'border-radius', '0 10px 10px 0' );
			}
		} );
		if ( bodyElement.hasClass( 'woocommerce-account' ) ) {
			$( '.woocommerce-notices-wrapper' ).before( $( '.entry-header' ) );
		}

		if ( bodyElement.hasClass( 'woocommerce-account' ) && $( '.doggy-id' ).length > 0 ) {
			// Change dogs name and recomendations on account page to selector
			let dogValue = document.querySelector( '.doggy-id' ).getAttribute( 'value' );
			let dogValueForDb = document.querySelector( '#doggy-id-for-database' );
			dogValueForDb.value = dogValue;

			let dogName = $( '.doggy__name' ).eq( 0 ).text();
			$( '#doggy-name-current span' ).text( dogName );
			if ( bodyElement.hasClass( 'woocommerce-account' ) && $( '.welcome' ).length > 0 ) {
				if ( $( '.doggy__name' ).length > 1 ) {
					$( '#doggy-name-current' ).addClass( 'select' );
					$( '#doggy-name-current' ).on( 'click', function () {
						$( '#doggy-name-current' ).toggleClass( 'active' );
						if ( $( '#doggy-name-current' ).hasClass( 'active' ) ) {
							$( '.doggy-names-wrapper' ).fadeIn( 200 );
							$( '.doggy-names-wrapper' ).addClass( 'active' );
							$( '.doggy__name' ).on( 'click', function ( event ) {
								let newDogName = $( event.currentTarget ).text();
								$( '#doggy-name-current span' ).text( newDogName );
								$( '.doggy-names-wrapper' ).fadeOut( 200 );
								$( '#doggy-name-current' ).removeClass( 'active' );

								let dogAttr = $( event.currentTarget ).attr( 'data-value' );
								$( '.photo-inner-wrapper' ).each( function ( i, r ) {
									let photoValue = $( r ).attr( 'data-value' );
									if ( dogAttr === photoValue ) {
										$( r ).css( 'display', 'flex' );
										$( r ).siblings( '.photo-inner-wrapper' ).hide();

									}
								} );
								$( '.doggy-id' ).each( function ( i, v ) {
									let dogId = $( v ).attr( 'data-value' );

									if ( dogAttr === dogId ) {
										dogValueForDb.value = $( v ).attr( 'value' );
									}
								} );
								$( '.funnel-wrapper' ).each( function ( i, el ) {
									let funnelAttr = $( el ).attr( 'data-value' );
									if ( dogAttr === funnelAttr ) {
										$( el ).siblings().fadeOut();
										$( el ).fadeIn();
									}
								} );
							} );
						} else {
							$( '.doggy-names-wrapper' ).fadeOut( 200 );
							$( '.doggy-names-wrapper' ).removeClass( 'active' );
						}
					} );
				}
			}

			const ajax = () => {
				$.ajax( {
					url: ajaxurl,
					type: 'POST',
					data: data,
					success: function ( response, status, jqXHR ) {
						// Status === OK
						if ( response.success ) {
							console.log( 'ok' );
						}
						// Error
						else {
							console.log( 'Error: ' + response.error );
						}
					},
					// Error response
					error: function ( jqXHR, status, errorThrown ) {
						console.log( 'Error response: ' + status );
					}
				} );
			};

			// add photo to account page

			const dogPhotoInputForDatabaseElement = document.getElementById( 'doggy-image-for-database' ),
				photoErrorFormatMessage = document.querySelector( '.doggy-error__format' ),
				photoErrorSizeMessage = document.querySelector( '.doggy-error__size' ),
				maxFileSize = 131072,
				defaultImageSrc = $( '.doggy-image-current' ).data( 'defaultSrc' );

			$( '.doggy-file-image' ).each( function ( i, el ) {
				if ( $( el ).siblings( '.doggy-image-current' ).attr( 'src' ) === defaultImageSrc ) {
					$( el ).siblings( '.delete-doggy-img' ).addClass( 'hidden' );
					$( el ).siblings( '.doggy-image-current' ).css( {
						'width': '71px',
						'height': '54px',
						'border-radius': '0'
					} );

				} else {
					$( el ).siblings( '.delete-doggy-img' ).removeClass( 'hidden' );
					$( el ).siblings( '.doggy-image-current' ).removeAttr( 'style' );

				}
			} );

			$( '.doggy-file-image' ).on( 'change', function ( event ) {
				const _eventTarget = event.currentTarget;
				let file;

				if ( _eventTarget.files[ 0 ] ) {
					file = _eventTarget.files[ 0 ];
				} else {
					return;
				}

				if ( !file.type.match( /image\/(jpeg|jpg|png|gif)/ ) ) {
					$( photoErrorSizeMessage ).addClass( 'hidden' );
					$( photoErrorFormatMessage ).removeClass( 'hidden' );
					return;
				}
				if ( file.size > maxFileSize ) {
					$( photoErrorFormatMessage ).addClass( 'hidden' );
					$( photoErrorSizeMessage ).removeClass( 'hidden' );
					return;
				}

				$( photoErrorSizeMessage ).addClass( 'hidden' );
				$( photoErrorFormatMessage ).addClass( 'hidden' );

				let reader = new FileReader();

				$( _eventTarget ).siblings( '.doggy-image-current' ).attr( 'src', URL.createObjectURL( file ) );
				$( _eventTarget ).siblings( '.delete-doggy-img' ).removeClass( 'hidden' );
				$( _eventTarget ).siblings( '.doggy-image-current' ).removeAttr( 'style' );

				reader.readAsDataURL( file );
				reader.onload = function () {
					let result = reader.result.toString();

					$( dogPhotoInputForDatabaseElement ).val( result );

					let fileImage = $( dogPhotoInputForDatabaseElement ).val(),
						dogId = $( '#doggy-id-for-database' ).val(),
						ajaxurl = myajax.ajaxurl,
						nonce = myajax.nonce;

					if ( typeof fileImage === undefined ) return;

					let data = {
						action: 'set_dog_profile_image',
						nonce: nonce,
						file: fileImage,
						id: dogId
					};

					// AJAX
					$.ajax( {
						url: ajaxurl,
						type: 'POST',
						data: data,
						success: function ( response, status, jqXHR ) {
							// Status === OK
							if ( response.success ) {
								console.log( 'ok' );
							}
							// Error
							else {
								console.log( 'Error: ' + response.error );
							}
						},
						// Error response
						error: function ( jqXHR, status, errorThrown ) {
							console.log( 'Error response: ' + status );
						}
					} );
				};

			} );

			// new ajax for delete photo from db
			$( '.delete-doggy-img' ).on( 'click', function ( event ) {
				$( event.currentTarget ).addClass( 'hidden' );
				$( event.currentTarget ).siblings( '.doggy-image-current' ).attr( 'src', defaultImageSrc );
				$( event.currentTarget ).siblings( '.doggy-image-current' ).css( {
					'width': '71px',
					'height': '54px',
					'border-radius': '0'
				} );

				$( event.currentTarget ).siblings( '.doggy-file-image' ).val( '' );

				photoErrorFormatMessage.classList.add( 'hidden' );
				photoErrorSizeMessage.classList.add( 'hidden' );

				let fileImage = '',
					dogId = $( '#doggy-id-for-database' ).val(),
					ajaxurl = myajax.ajaxurl,
					nonce = myajax.nonce;

				let data = {
					action: 'set_dog_profile_image',
					nonce: nonce,
					file: fileImage,
					id: dogId
				};

				// AJAX
				$.ajax( {
					url: ajaxurl,
					type: 'POST',
					data: data,
					success: function ( response, status, jqXHR ) {
						// Status === OK
						if ( response.success ) {
							console.log( 'ok' );
						}
						// Error
						else {
							console.log( 'Error: ' + response.error );
						}
					},
					// Error response
					error: function ( jqXHR, status, errorThrown ) {
						console.log( 'Error response: ' + status );
					}
				} );
			} );

		}
		$( '.new-select__list' ).each( function ( i, el ) {
			if ( $( this ).children().length < 13 ) {
				$( this ).css( { 'height': '100%', 'min-height': '160px' } );
			}
		} );

		// added trustpilot to checkout

		$( document ).on( 'ajaxStop', function () {
			$( '.left-col .content-wrapper' ).append( $( '.after-checkout .trustpilot-widget' ) );
		} );

		$( '.dog-form li .button--secondary' ).each( function ( i, el ) {
			$( el ).on( 'click', function ( event ) {

				if ( !$( el ).hasClass( 'active' ) ) {
					$( el ).parents( '.dog-profile' ).siblings( '.dog-profile' ).children( '.dog-form' ).children( 'li:not(:first-child)' ).slideUp( 200 );
					$( el ).parents( '.dog-profile' ).siblings( '.dog-profile' ).children( '.button-remove-wrapper' ).slideUp( 200 );
					$( el ).parents( '.dog-profile' ).siblings( '.dog-profile' ).children( '.dog-form' ).children( 'li:first-child' ).children( 'a' ).removeClass( 'active' );
					$( el ).parents( '.dog-profile' ).siblings( '.dog-profile' ).children( '.woocommerce-Button.button.button--secondary' ).slideUp( 200 );

					$( el ).addClass( 'active' );
					$( el ).parent().siblings( 'li' ).slideDown( 200 );
					$( el ).parent( 'li' ).parent( '.dog-form' ).siblings( '.button-remove-wrapper' ).slideDown( 200 );
					$( el ).parent( 'li' ).parent( '.dog-form' ).siblings( '.woocommerce-Button' ).slideDown( 200 );

				} else {
					$( el ).removeClass( 'active' );
					$( el ).parent().siblings( 'li' ).slideUp( 200 );
					$( el ).parent( 'li' ).parent( '.dog-form' ).siblings( '.button-remove-wrapper' ).slideUp( 200 );
					$( el ).parent( 'li' ).parent( '.dog-form' ).siblings( '.woocommerce-Button' ).slideUp( 200 );

				}
			} );
		} );

		/*
		* Footer form ajax
		* https://www.wrike.com/open.htm?id=630129082
		 */

		let footerSubscribeForm = $( 'footer#colophon form.subscribe-form' ),
			submitButtonText = $( '.subscribe-form .button-text' ).text(),
			nonce = myajax.nonce;

		const validateEmail = email => {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test( String( email ).toLowerCase() );
		};

		footerSubscribeForm.submit( function ( event ) {
			event.preventDefault();

			let url = myajax.ajaxurl,
				email = $( 'footer#colophon form.subscribe-form .subscribe-form__email' ).val();

			if ( !validateEmail( email ) ) {
				$( this ).addClass( 'error' );
				return;
			}

			$( this ).removeClass( 'error' );

			let data = {
				'action': 'fl_builder_subscribe_form_submit',
				'email': email,
				'nonce_code': nonce,
			};

			$.ajax( {
				method: 'post',
				url: url,
				data: data,
				beforeSend: function () {
					const button_text_element = $( '.subscribe-form .button-text' ),
						wait_text = button_text_element.data( 'wait_text' );
					button_text_element.text( wait_text );
					$( '.subscribe-form__button' ).attr( 'disabled', 'disabled' );
				},
				error: function ( newRequest, newStatus, error ) {
					console.log( 'error ' + error );
				},
				success: function ( newResponse, newStatus, newJqXHR ) {
					console.log( 'form sent successfully with response text - ' + newJqXHR.responseText );
					const button_text_element = $( '.subscribe-form .button-text' ),
						thanks_text = button_text_element.data( 'thanks_text' );
					button_text_element.text( thanks_text );
					$( '.subscribe-form__button' ).css( 'pointer-events', 'none' );
					$( '.subscribe-form input' ).val( '' );

					setTimeout( function () {
						$( '.subscribe-form .button-text' ).text( submitButtonText );
						$( '.subscribe-form__button' ).css( 'pointer-events', 'auto' );
					}, 5000 );
				},
				complete: function () {
					$( '.subscribe-form__button' ).removeAttr( 'disabled' );
				}
			} );
		} );

		// back to the previous page from checkout page

		$( '.back-link a' ).on( 'click', function ( e ) {
			e.preventDefault();
			window.history.back();
		} );

		// view chat when click in the contact page on callout module
		const dixaWrapper = document.querySelector( '#chat-dixa-callout' );

		if ( dixaWrapper ) {
			dixaWrapper.addEventListener( 'click', () => {
				window._dixa( 'api.setView', 'conversation' );
			} );
		}
	};

	const scrollToElement = ( selector ) => {
		const hT = $( selector ).offset().top,
			hH = $( selector ).outerHeight(),
			wH = $( window ).height(),
			wS = $( this ).scrollTop();

		if ( wS > ( hT + hH - wH ) && ( hT > wS ) && ( wS + wH > hT + hH ) ) {
			if ( !$( selector ).hasClass( 'active' ) ) {
				$( selector ).addClass( 'active' );
			}
		}
	};

	$( window ).scroll( function () {
		if ( !$( '.crossed-first-wrapper' ).length > 0 && !$( '.crossed-wrapper' ).length > 0 && !$( '.home-arrow-wrap' ).length > 0 ) return;
		scrollToElement( '.crossed-first-wrapper' );
		scrollToElement( '.crossed-wrapper' );
		scrollToElement( '.home-arrow-wrap' );
	} );

	/**
	 * Menu om oss back
	 */

	$( '.menu-back' ).on( 'click', function ( e ) {
		e.preventDefault();
		window.history.back();
	} );

	/**
	 * Accordion with pb
	 */

	const accordionItem = $( '.home-how-wrap .fl-accordion-item' );

	const setAccordionImage = ( item, image, index ) => {
		let _item = $( item ),
			_image = $( image );
		if ( _item.hasClass( `accordion-tab-${ index }` ) ) {
			_image.fadeIn( 200 );
			_image.siblings( '.fl-module-photo' ).hide();
		}
	};

	accordionItem.each( function ( i, item ) {
		let _this = $( this );
		_this.attr( 'data-index', i );

		_this.addClass( 'accordion-tab-' + i );
		let tabFirst = $( '.accordion-tab-0' );
		let tabSecond = $( '.accordion-tab-1' );
		let tabThird = $( '.accordion-tab-2' );

		if ( $( window ).width() > 767 ) {
			tabFirst.on( 'click', () => {
				setAccordionImage( '.accordion-tab-0', '.accordion-photo--happy', 0 );
			} );

			tabSecond.on( 'click', () => {
				setAccordionImage( '.accordion-tab-1', '.accordion-photo--box', 1 );
			} );

			tabThird.on( 'click', () => {
				setAccordionImage( '.accordion-tab-2', '.accordion-photo--food', 2 );
			} );
		}
	} );

	/**
	 * Mobile About Us menu styling
	 */

	const aboutUsMobileDropdown = document.querySelector( '.about-us-mobile' );

	if ( aboutUsMobileDropdown ) {
		new Choices( aboutUsMobileDropdown, {
			searchEnabled: false,
			itemSelectText: '',
			shouldSort: false,
			placeholder: false,
		} );

		aboutUsMobileDropdown.addEventListener( 'change', event => {
			window.location = event.target.value;
		} );
	}

	const initializeChoices = ( elem ) => {
		elem.forEach( item => {
			new Choices( item, {
				searchEnabled: false,
				itemSelectText: '',
				shouldSort: false,
				placeholder: false,
				position: 'bottom',
			} );
		} );
	};

	const exchangeSelect = document.querySelectorAll( '.variation-select-element' );
	const productQuantityButton = $( '.product-quantity--button' );

	if ( exchangeSelect ) {
		initializeChoices( exchangeSelect );
	}

	const handleQtyClick = ( event ) => {
		const _this = $( event.currentTarget ),
			_inputElement = _this.siblings( '.quantity-input' ),
			_minValue = parseInt( _inputElement.attr( 'min' ) ),
			_maxValue = parseInt( _inputElement.attr( 'max' ) ),
			_stepValue = parseInt( _inputElement.attr( 'step' ) ),
			_qty = parseInt( _inputElement.val() );
		let _newQty;

		if ( _this.hasClass( 'product-quantity--minus' ) ) {
			_newQty = _qty - _stepValue;
			if ( _newQty >= _minValue ) {
				_inputElement.attr( 'value', _newQty ).val( _newQty ).trigger( 'change' );
			}

		} else if ( _this.hasClass( 'product-quantity--plus' ) ) {
			_newQty = _qty + _stepValue;
			if ( _newQty <= _maxValue ) {
				_inputElement.attr( 'value', _newQty ).val( _newQty ).trigger( 'change' );
			}
		} else {
			return false;
		}
	};

	$( document ).on( 'ajaxComplete', function ( event, xhr, settings ) {
		if ( settings.data?.includes( 'wcs_exchange_cart' ) ) {
			const exchangeSelect = document.querySelectorAll( '.variation-select-element' );
			if ( exchangeSelect ) {
				initializeChoices( exchangeSelect );
			}
		}
	} );

	productQuantityButton.on( 'click', function ( e ) {
		handleQtyClick( e );
	} );

	/**
	 * To make sure JS is initialized after the page is ready we make it through timers
	 */
	setTimeout( __theme_js_init, 300 );
	setTimeout( __remove_cart_item, 500 );
	setTimeout( __refresh_minicart, 100 );

} );
